import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { Input } from "../../inputs";

const Bullet = ({ id, index, label, readOnly, remove, update, value }) => {
    if (readOnly && !value) {
        return null;
    }

    return (
        <div className="product-compare-row" style={{ gridTemplateColumns: "150px repeat(1, 1fr)" }}>
            <div className="row-header">{label}</div>
            <div className="input-group -no-margin">
                <Input
                    id={id}
                    name="bullet"
                    value={value}
                    updateOnBlur={(n, v) => {
                        update(index, v);
                    }}
                    disabled={readOnly}
                />
                {!readOnly && (
                    <button className="button -primary" onClick={remove}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Bullet;
